<template>
  <div class="yo-chat-room-list-view">
    <div class="overlay-chatroom">
      <!-- <TitleOfChatRoom class="show-desktop" :room="currentRoom" @toggle="(v) => { openMenu = !openMenu }"></TitleOfChatRoom> -->
      <div class="yoteach-chatroom">
        <RedBar @earthflow="autoShowEarth" @switch="(v) => { $emit('switch', v) }" :room="currentRoom" @main="(v) => { main = v }" @bar="(v) => { bar = v }" @roomTitle="(v) => { roomTitle = v }" :roomID="currentRoomID" @overlay="(v) => { overlay = v }" />
        <ListOfCreateRoom v-if="bar === 'create'" @switch="(v) => { $emit('switch', v) }" @main="(v) => { main = v }" @bar="(v) => { bar = v }"  @currentRoomID="(v) => { currentRoomID = v }" :openMenu="openMenu" :currentRoomID="currentRoomID" @currentRoom="onRoomSel" @openMenu="(v) => { openMenu = v }"></ListOfCreateRoom>
        <ListOfOnlineUser v-if="bar === 'online'" @switch="(v) => { $emit('switch', v) }" @main="(v) => { main = v }" @bar="(v) => { bar = v }"  :openMenu="openMenu" :currentRoomID="currentRoomID" @currentRoom="onRoomSel" @openMenu="(v) => { openMenu = v }"></ListOfOnlineUser>
        <!-- <ListOfCourseRooms v-if="bar === 'buhk' && marker === 'buhk'" @switch="(v) => { $emit('switch', v) }" @main="(v) => { main = v }" @bar="(v) => { bar = v }"  :openMenu="openMenu" :currentRoomID="currentRoomID" @currentRoom="onRoomSel" @openMenu="(v) => { openMenu = v }"></ListOfCourseRooms> -->
        <ListOfCourseRooms v-if="bar === 'earthcourse'" :userID="ownerID" :earthID="earthID" @currentRoomID="(v) => { currentRoomID = v }" @earthflow="autoShowEarth"  @switch="(v) => { $emit('switch', v) }" @main="(v) => { main = v }" @bar="(v) => { bar = v }"  :openMenu="openMenu" :currentRoomID="currentRoomID" @currentRoom="onRoomSel" @openMenu="(v) => { openMenu = v }"></ListOfCourseRooms>
        <ListOfSearchResult v-if="bar === 'search'" @switch="(v) => { $emit('switch', v) }" @main="(v) => { main = v }" @bar="(v) => { bar = v }"  :openMenu="openMenu" :currentRoomID="currentRoomID" @currentRoom="onRoomSel" @openMenu="(v) => { openMenu = v }"></ListOfSearchResult>
        <ListOfRooms v-if="bar === 'favourite'" @switch="(v) => { $emit('switch', v) }" @main="(v) => { main = v }" @bar="(v) => { bar = v }"  :openMenu="openMenu" :currentRoomID="currentRoomID" @currentRoom="onRoomSel" @openMenu="(v) => { openMenu = v }"></ListOfRooms>

        <ViewOfChat class="main-view" :openMenu="openMenu" :roomID="currentRoomID" v-if="refresher && main === 'chat'" @switch="(v) => { $emit('switch', v) }" @openMenu="(v) => { openMenu = v }"></ViewOfChat>
        <YoEarthWelcome v-if="main === 'earth-welcome'" class="main-view"></YoEarthWelcome>
        <YoEarthSelfIntroduction :earthID="earthID" :userID="ownerID" @earthflow="autoShowEarth" v-if="main === 'earth-self-intro'" class="main-view"></YoEarthSelfIntroduction>
        <YoEarthPins :earthID="earthID" :userID="ownerID"  @pinuser="(v) => { pinuser = v }" v-if="main === 'earth-pins'" @overlay="(v) => { overlay = v }" class="main-view"></YoEarthPins>
      </div>
    </div>
    <!-- <div class="overlay-page-wide" v-if="true">
      {{ earthID }}
      {{ ownerID }}
    </div> -->

    <div class="overlay-page-wide" v-if="overlay === 'users'">
      <Portfolio v-if="pinuser" :pinuser="pinuser" @close="() => { overlay = '' }"></Portfolio>
    </div>
    <div class="overlay-page-wide" v-if="overlay === 'admin'">
      <AdminPanelLogin @overlay="(v) => { overlay = v }" @close="() => { overlay = '' }"></AdminPanelLogin>
    </div>
    <div class="overlay-page-wide" v-if="overlay === 'admin-panel'">
      <AdminPanelControls :userID="ownerID" :earthID="earthID" @overlay="(v) => { overlay = v }" @close="() => { overlay = '' }"></AdminPanelControls>
    </div>
  </div>
</template>

<script>
// import TitleOfChatRoom from './SubCompos/TitleOfChatRoom.vue'
import { API } from '@/yoteach2-gui/parts/index.js'
import { Status } from './parts/YoNetwork/YoNetwork.js'

const RedBar = () => import('./SubCompos/RedBar.vue')
const ViewOfChat = () => import('./SubCompos/ViewOfChat.vue')
const ListOfCreateRoom = () => import('./SubCompos/ListOfCreateRoom.vue')
const ListOfRooms = () => import('./SubCompos/ListOfRooms.vue')
const ListOfCourseRooms = () => import('./SubCompos/ListOfCourseRooms.vue')
const ListOfSearchResult = () => import('./SubCompos/ListOfSearchResult.vue')
const ListOfOnlineUser = () => import('./SubCompos/ListOfOnlineUser.vue')
const Portfolio = () => import('./SubCompos/Portfolio.vue')
const AdminPanelLogin = () => import('./SubCompos/AdminPanelLogin.vue')
const AdminPanelControls = () => import('./SubCompos/AdminPanelControls.vue')

const YoEarthWelcome = () => import('./YoEarth/YoEarthWelcome.vue')
const YoEarthSelfIntroduction = () => import('./YoEarth/YoEarthSelfIntroduction.vue')
const YoEarthPins = () => import('./YoEarth/YoEarthPins.vue')

// let rootFix = `/lab/`

export default {
  props: {
    earthID: {},
    ownerID: {}
    // initCreateRoomTitle: {},
    // initRoomTitle: {},
    // marker: {},
    // userData: {}
  },
  components: {
    AdminPanelControls,
    AdminPanelLogin,
    Portfolio,
    YoEarthPins,
    YoEarthWelcome,
    YoEarthSelfIntroduction,
    RedBar,
    ViewOfChat,
    ListOfRooms,
    ListOfSearchResult,
    ListOfCreateRoom,
    ListOfCourseRooms,
    ListOfOnlineUser // ,
    // TitleOfChatRoom
  },
  data () {
    this.$root.earthID = this.earthID
    this.$root.ownerID = this.ownerID
    return {
      roomTitle: '',
      pinuser: {},
      main: 'earth-welcome',
      bar: window.innerWidth > 767 ? 'earthcourse' : 'search',
      currentRoom: false,
      openMenu: false,
      refresher: true,
      currentRoomID: false,
      overlay: 'fabricboard',
      msgs: []
    }
  },
  watch: {
    roomID () {
      this.loadURLRoom()
    },
    roomTitle () {
      this.loadURLRoom()
    }
  },
  async mounted () {
    // console.log(this.marker)
    // console.log(this.userData)
    // if (this.marker === 'buhk') {
    //   this.initBUHKFlow()
    // }

    // this.loadURLRoom()

    this.runYoEarthFlow()

    // try {
    //   await this.getRoomIDByTitle({ title: this.roomTitle })
    //   this.loadURLRoom()
    // } catch (e) {
    //   await this.createRooom({ title: this.initCreateRoomTitle })
    // }
  },
  computed: {
    // roomTitle () {
    //   return this.initRoomTitle
    //   // return this.$route.fullPath.replace(`${rootFix}`, '')
    // }
  },
  methods: {
    runYoEarthFlow () {
      console.log(Status)
      this.autoShowEarth()
    },
    autoShowEarth () {
      this.main = 'earth-welcome'
      if (Status.state.chatter && Status.state.chatter.uuid) {
        this.main = 'earth-pins'
      } else {
        this.main = 'earth-self-intro'
      }

      // this.main = 'earth-self-intro'
      this.$forceUpdate()
    },
    // initBUHKFlow () {
    //   API.OPTIONS.log = true
    //   API.OPTIONS.userData = this.userData
    //   API.OPTIONS.marker = this.marker
    //   this.bar = 'buhk'
    // },
    async createRooom ({ title }) {
      let isUnique = await this.checkUniqueTitle({ title: this.newName })
      if (isUnique) {
        let template = {
          title,
          desc: '',

          hideFromSearchResult: false,

          enableRoomAdminFeatures: false,
          roomAdminPassword: '',
          roomAdminPasswordRecoveryQuestion: '',
          roomAdminPasswordRecoveryAnswer: '',

          enableRoomEntryPassword: false,
          roomEntryPassword: '',

          sortMethod: 'chat',

          adminUUIDs: [],
          mutedUUIDs: []
        }
        let resp = await API.createRoom({ ...template })
        this.onRoomSel(resp.data)
        // this.setTo('bar', 'none')
        // this.setTo('currentRoom', resp.data)
        // this.setTo('openMenu', false)
        // this.setTo('currentRoomID', resp.data._id)
      } else {
        this.loadURLRoom()
      }
    },
    checkUniqueTitle ({ title }) {
      return API.checkRoomNameTaken({
        title
      }).then(() => {
        var idx = this.msgs.findIndex(m => m.id === 503)
        if (idx !== -1) {
          this.msgs.splice(idx, 1)
        }
        return true
      }, () => {
        if (this.msgs.findIndex(m => m.id === 503) === -1) {
          this.msgs.push({ id: 503, msg: 'Room name is taken' })
        }
        return false
      })
    },
    setTo (field, val) {
      this[field] = val
    },
    onRoomSel ({ _id, title }) {
      this.openMenu = false
      // this.$router.push(`${rootFix}${title}`)
      this.$emit('initRoomTitle', `${title}`)
      this.currentRoomID = _id
      this.refresher = false
      setTimeout(() => {
        this.refresher = true
      }, 30)
    },
    async loadURLRoom () {
      try {
        this.currentRoom = await this.getRoomIDByTitle({ title: this.roomTitle })
        this.refresher = false
        setTimeout(() => {
          this.currentRoomID = this.currentRoom._id
          this.refresher = true
        }, 10)
      } catch (e) {
        this.currentRoomID = null
        this.openMenu = true
      }
    },
    async getRoomIDByTitle ({ title }) {
      var resp = await API.getIdByTitle({ title })
      var room = resp.data
      // var roomID = to.params.roomID
      return room
    }
  }
}
</script>

<style scoped>
.yo-chat-room-list-view{
  position: relative;
  width: 100%;
  height: 100%;
}
.overlay-chatroom{
  width:100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  overflow: hidden;
}
.overlay-page-wide{
  z-index: 1000000;
  width:100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: rgba(255,255,255,0.9);
}
.yoteach-chatroom{
  width: 100%;
  height: calc(100%);
  overflow: hidden;
  display: flex;
}
.show-desktop{
  display: none;
}
.main-view{
  position: absolute;
  right: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
}
@media screen and (min-width: 767px) {
  .show-desktop{
    display: block;
  }
  .yoteach-chatroom{
    height: calc(100%);
  }
  .main-view{
    width: calc(100% - 303px);
    height: 100%;
  }
}

@media screen and (min-width: 767px) {
  .hide-desktop{
    display: none !important;
  }
}

</style>
